<template>
  <div class="index-1-left-1">
    <div class="index-title">
      <span>{{ $t("propertyIndex.communityInfo") }}</span>
    </div>

    <!-- 第一行：总房间数 / 出租率 / 空置率 / 本月收入 -->
    <div class="flex justify-between border-bottom index-1-left-1-content">
      <!-- 房间总数 -->
      <div class="flex justify-center">
        <div class="index-1-left-img">
          <i class="el-icon-office-building"></i>
        </div>
        <div>
          <div class="index-number">{{ communityData.total || 0 }}</div>
          <div class="index-number-describe">总房间数</div>
        </div>
      </div>

      <!-- 出租率 -->
      <div class="flex justify-center">
        <div class="index-1-left-img">
          <svg
            t="1762309269665"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="11156"
            width="32"
            height="32"
          >
            <path
              d="M257.13 891.415h527.823V638.463h68.856v252.952c0 38.082-30.775 68.967-68.856 68.967H257.13c-38.081 0-68.856-30.885-68.856-68.967V638.463h68.856v252.952z m665.534-321.918L509.529 178.61 96.503 592.52l-45.941-68.966L509.529 63.704 991.52 523.556l-68.857 45.94z"
              fill="#409eff"
              p-id="11157"
            ></path>
            <path
              d="M370.524 688.192c17.613-24.736 32.23-56.121 43.848-94.16H371.93v-19.957h45.815v-44.41a3037.998 3037.998 0 0 1-38.788 2.81c-0.938-6.37-2.343-13.21-4.216-20.518 39.162-2.25 72.799-5.34 100.906-9.275l5.06 21.361c-11.244 1.125-25.298 2.438-42.162 3.935v46.097h44.41v19.956h-44.41v37.946l12.367-10.963c11.054 10.681 23.048 23.424 35.978 38.225l-16.022 13.774c-12.18-15.551-22.956-28.108-32.323-37.665v129.576h-20.8V639.283c-9.932 27.546-22.394 51.908-37.383 73.08-3-7.869-6.28-15.926-9.838-24.171z m92.755 44.972h33.729v-227.11h128.734v227.11h24.172v19.957H463.279v-19.957z m55.653-207.154v55.654h84.885V526.01h-84.885z m0 130.982h84.885V601.34h-84.885v55.652z m0 76.172h84.885v-56.497h-84.885v56.497z"
              fill="#409eff"
              p-id="11158"
            ></path>
          </svg>
        </div>
        <div>
          <div class="index-number">{{ communityData.czl || "0.0%" }}</div>
          <div class="index-number-describe">出租率</div>
        </div>
      </div>

      <!-- 空置率 -->
      <div class="flex justify-center">
        <div class="index-1-left-img">
          <svg
            t="1762309063230"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="7925"
            width="32"
            height="32"
          >
            <path
              d="M227.6 626.4v279.1H125.1V626.4h102.5m50-50H75.1v379.1h202.5V576.4z"
              fill="#FD9437"
              p-id="7926"
            ></path>
            <path
              d="M464.1 96.6v808.9H356.6V96.6h107.5m50-50H306.6v908.9h207.5V46.6zM697.1 455v450.5H591.6V455h105.5m50-50H541.6v550.5h205.5V405zM931.1 340v565.5H825.6V340h105.5m50-50H775.6v665.5h205.5V290z"
              fill="#1E62ED"
              p-id="7927"
            ></path>
          </svg>
        </div>
        <div>
          <div class="index-number">{{ communityData.kzl || "0.0%" }}</div>
          <div class="index-number-describe">空置率</div>
        </div>
      </div>

      <!-- 本月收入 -->
      <div class="flex justify-center">
        <div class="index-1-left-img">
          <svg
            t="1762309224468"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="9962"
            width="32"
            height="32"
          >
            <path
              d="M625.586441 682.666667H530.961256a37.925926 37.925926 0 1 0 0 75.851852h94.625185v95.04237a37.925926 37.925926 0 1 0 75.851852 0V758.518519H796.442738a37.925926 37.925926 0 1 0 0-75.851852h-95.004445v-94.58726a37.925926 37.925926 0 1 0-75.851852 0V682.666667zM450.937553 447.981037C243.861997 448.018963 75.850145 362.154667 75.850145 256V191.981037C75.850145 86.091852 242.951775 0 450.254886 0c207.265185 0 375.087407 85.864296 375.087407 192.018963V257.137778c0.227556 51.655111-40.391111 98.683259-105.585777 133.12a326.162963 326.162963 0 0 0-50.517334-5.12 335.416889 335.416889 0 0 0-195.318518 62.805333H450.937553z m-107.89926 182.954667h0.227556C189.021108 607.194074 75.850145 535.286519 75.850145 448.018963V340.005926c0 98.455704 145.294222 161.754074 331.927704 170.135704a352.938667 352.938667 0 0 0-64.739556 120.794074z m-5.726814 191.070815l0.227555 0.227555C186.252516 797.316741 75.850145 725.636741 75.850145 640v-107.975111c0 84.233481 106.723556 142.866963 253.876148 163.119407a356.124444 356.124444 0 0 0-4.133926 40.732445c0.379259 29.089185 4.323556 58.026667 11.719112 86.091852z m25.258666 69.783703v-0.455111A351.952593 351.952593 0 0 0 471.607182 1024H450.937553C243.861997 1024 75.850145 938.135704 75.850145 831.981037V724.005926c0 90.529185 122.576593 151.286519 286.72 167.822222zM666.925701 447.525926c156.103111 0.910222 281.979259 129.85837 281.22074 288.123259 0 116.811852-69.594074 222.056296-176.128 266.467556a281.41037 281.41037 0 0 1-310.08237-63.829334 291.043556 291.043556 0 0 1-59.657481-315.01274c44.904296-107.557926 149.428148-176.96237 264.647111-175.748741z"
              fill="#409eff"
              p-id="9963"
            ></path>
          </svg>
        </div>
        <div>
          <div class="index-number">{{ communityData.bysr || "0.0" }}</div>
          <div class="index-number-describe">本月收入</div>
        </div>
      </div>
    </div>

    <!-- 第二行：总房屋面积 / 出租面积 / 租赁中 / 空置中 -->
    <div class="flex justify-between index-1-left-1-bottom">
      <!-- 总房屋面积 -->
      <div class="flex justify-center index-1-left-1-bottom-item">
        <div class="index-1-left-img">
          <i class="el-icon-s-data"></i>
        </div>
        <div class="ml-3">
          <div class="index-number">
            {{ communityData.totalAllArea || "0.00" }}
            <span class="index-number-unit">㎡</span>
          </div>
          <div class="index-number-describe">总房屋面积</div>
        </div>
      </div>
      <!-- 出租面积 -->
      <div class="flex justify-center index-1-left-1-bottom-item">
        <div class="index-1-left-img">
          <i class="el-icon-s-data"></i>
        </div>
        <div class="ml-3">
          <div class="index-number">
            {{ communityData.totalRentArea || "0.00" }}
            <span class="index-number-unit">㎡</span>
          </div>
          <div class="index-number-describe">出租面积</div>
        </div>
      </div>
      <!-- 租赁中 2001 -->
      <div class="flex justify-center index-1-left-1-bottom-item">
        <div class="index-1-left-img">
          <i class="el-icon-check"></i>
        </div>
        <div class="ml-3">
          <div class="index-number">
            {{ (communityData.fwztsl && communityData.fwztsl["2001"]) || 0 }}
            <span class="index-number-unit">个</span>
          </div>
          <div class="index-number-describe">租赁中</div>
        </div>
      </div>
      <!-- 空置中 2008 -->
      <div class="flex justify-center index-1-left-1-bottom-item">
        <div class="index-1-left-img">
          <i class="el-icon-check"></i>
        </div>
        <div class="ml-3">
          <div class="index-number">
            {{ (communityData.fwztsl && communityData.fwztsl["2008"]) || 0 }}
            <span class="index-number-unit">个</span>
          </div>
          <div class="index-number-describe">空置中</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IndexCommunity",
  props: {
    repairData: {
      type: Object,
      default: () => ({}),
    },
    roomStateMap: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      communityData: {},
      stateIcons: {
        租赁中: "el-icon-check",
        未销售: "el-icon-check",
        已交房: "el-icon-check",
        未入住: "el-icon-check",
        已装修: "el-icon-check",
        已售: "el-icon-check",
        空置中: "el-icon-check",
        装修中: "el-icon-check",
        借用中: "el-icon-check",
        免租期: "el-icon-check",
        未知状态: "el-icon-info",
      },
    };
  },
  computed: {
    displayRoomStates() {
      const fwztsl = this.communityData.fwztsl || {};
      if (typeof fwztsl !== "object" || Array.isArray(fwztsl)) {
        return [];
      }
      const stateList = [];
      const stateCodes = Object.keys(fwztsl);
      if (stateCodes.length === 0) {
        return [];
      }
      stateCodes.forEach((stateCode) => {
        const count = Number(fwztsl[stateCode]);
        if (isNaN(count) || count < 0) {
          return;
        }
        const stateName = this.roomStateMap[stateCode]
          ? this.roomStateMap[stateCode]
          : `未知状态(${stateCode})`;
        stateList.push({
          stateCode,
          stateName,
          count,
          icon: this.stateIcons[stateName] || this.stateIcons["未知状态"],
        });
      });
      return stateList.sort((a, b) => b.count - a.count).slice(0, 4);
    },
  },
  mounted() {
    this.communityData = this.repairData;
  },
  watch: {
    repairData: {
      handler(newVal) {
        this.communityData = newVal;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.index-1-left-1 {
  background: #fff;
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  .index-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    text-align: left;
    color: #333;
    padding-bottom: 5px;
    border-bottom: 1px solid #f5f5f5;
  }

  .index-1-left-1-content {
    padding: 40px 0;
    border-bottom: 1px solid #f5f5f5;

    > div {
      width: 25%;
      text-align: center;
    }

    .index-1-left-img {
      width: 40px;
      height: 40px;
      background: #f0f7ff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;

      i {
        font-size: 20px;
        color: #409eff;
      }
    }

    .index-number {
      font-size: 24px;
      font-weight: bold;
      color: #333;
      line-height: 1.2;
    }

    .index-number-describe {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }
  }
}

  .index-1-left-1-bottom {
    padding: 40px 0;
    display: flex;
    justify-content: space-between;

    .index-1-left-1-bottom-item {
      width: 22%;
      display: flex;
      align-items: center;

      .index-1-left-img {
        width: 40px;
        height: 40px;
        background: #f0f7ff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;

        i {
          font-size: 20px;
          color: #409eff;
        }
      }

      .index-number {
        font-size: 24px;
        font-weight: bold;
        color: #333;
        line-height: 1.2;

        .index-number-unit {
          font-size: 12px;
          color: #999;
          margin-left: 3px;
        }
      }

      .index-number-describe {
        font-size: 12px;
        color: #999;
        margin-top: 5px;
      }
    }

    .no-data {
      width: 100%;
      text-align: center;
      padding: 30px 0;
      color: #999;
      font-size: 14px;
    }
  }

  .ml-3 {
    margin-left: 10px;
  }
</style>